import { useTranslation } from "react-i18next";
import { getSignedImageSrc } from "../../mediaUtils";
import { isBlank, isEmptyList, isNullOrUndefined } from "../../utils";
import ToggleSwitch from "../ToggleSwitch";

function PhotoGrid(props) {
  const { feedItems, includeNotes, onToggleIncludeNotes, onClick } = props;
  const { t } = useTranslation();

  return (
    <div className="photo-grid">
      <div className="photo-grid-header">
        <div>
          <div>
            <h4>{`${feedItems.length} ${t("events").toLowerCase()}`}</h4>
          </div>
          <div>
            <div className="notes-switch">
              <div>{t("include_notes")}</div>
              <div>
                <ToggleSwitch
                  isSelected={includeNotes}
                  onChange={onToggleIncludeNotes}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      {!isEmptyList(feedItems) && (
        <div className="photo-grid-thumbnails">
          {feedItems &&
            feedItems.map((feedItem) => (
              <PhotoGridThumbnail
                feedItem={feedItem}
                key={feedItem.uuid}
                onClick={onClick}
              />
            ))}
        </div>
      )}
    </div>
  );
}

function PhotoGridThumbnail(props) {
  const { feedItem, onClick } = props;
  const hasImage = !isNullOrUndefined(feedItem.image);
  const hasNotes = !isBlank(feedItem.notes);
  const thumbnailSrc = hasImage
    ? getSignedImageSrc(feedItem.image?.thumbnail)
    : null;

  const thumbnailStyle = {
    backgroundImage: `url(${thumbnailSrc})`,
  };

  return (
    <div
      className="photo-grid-thumbnail"
      data-imagesrc={hasImage ? feedItem.image?.thumbnail : ""}
      style={thumbnailStyle}
      onClick={() => {
        onClick(feedItem);
      }}
    >
      {!hasImage && hasNotes && (
        <div
          className="photo-grid-notes-placeholder"
          onClick={() => {
            onClick(feedItem);
          }}
        >
          <div>{feedItem.notes.substring(0, 1)}</div>
        </div>
      )}
    </div>
  );
}

export default PhotoGrid;
